import VersionModalView from '../topnavbar/versionModal.html';


angular.module("topnavbar", ['ui.bootstrap'])

    .controller('topnavbarCtrl', ['$uibModal', '$scope', '$translate', 'Restangular', '$state', '$http', '$rootScope', 'LoginService', 'logService',
        function ($uibModal, $scope, $translate, Restangular, $state, $http, $rootScope, LoginService, logService) {

        $scope.currentDate = new Date();

        Restangular.all('Languages').getList({ use_for_interface: true }).then(function (languages) {
            $scope.languages = languages;
            angular.forEach(languages, function (lang) {
                if (lang.code == LoginService.get("language")) {
                    $rootScope.languageId = lang.id;
                }
            });
        });

        $rootScope.roles_permissions = LoginService.get("rolesPermissions");

        $scope.changeLanguage = function (key, languageId) {
            $translate.use(key);
            let language = key;
            $rootScope.language = key;
//            setCookie("language", key, 10);
            $http.defaults.headers.common["language_code"] = key;
            $rootScope.languageId = languageId;
            $rootScope.$broadcast("language-change", { key: key });
            $state.reload();
        };

        $scope.changeTheme = function (theme) {
            $rootScope.theme = theme;
            localStorage.setItem("theme", theme);
        };

        $scope.versions = [];

        $rootScope.showVersion = function () {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: VersionModalView,
                controller: "VersionModalCtrl",
                resolve: {
                    project_code: function () {
                        return (window as any).CONFIG.PROJECT_CODE;
                    },
                    version: function () {
                        return $scope.versions[0];
                    }
                }
            });
        }
    }])
    .controller('topnavbarSearchCtrl', ['$uibModal', '$scope', '$translate', 'Restangular', '$state', '$http', '$rootScope', 'LoginService', function ($uibModal, $scope, $translate, Restangular, $state, $http, $rootScope, LoginService) {
        $scope.asyncSelected = '';
        
        $scope.itemSelected = function ($item, $model, $label) {
            let stateName: string | null = null;
            let stateParams: any = { id: $item.id };
            if($item.entity === 'person' || $item.related_entity === 'person') {
                stateName = 'persons.edit';
                stateParams.person_type = 'authority';
            } else if($item.entity === 'group' || $item.related_entity === 'group') {
                stateName = 'groups.edit';
            } else if($item.entity === 'event') {
                stateName = 'events.edit';
                stateParams.is_template = false;
            } else if($item.entity === 'correspondence') {
                stateName = 'correspondence.edit';
            } else if($item.entity === 'gift') {
                stateName = 'gifts.edit';
            } else if($item.entity === 'restaurant') {
                stateName = 'restaurants.edit';
            } else if($item.entity === 'material') {
                stateName = 'materials.edit';
            } else if($item.entity === 'space') {
                stateName = 'spaces.list';
                stateParams = {};
            }
            if(stateName != null) {
                if($item.related_entity_id !== undefined && $item.related_entity_id > 0) {
                    stateParams.id = $item.related_entity_id;
                }
                $state.go(stateName, stateParams);
            }
        };
        
        $scope.getTerms = function(val) {
            return Restangular.all('search?term=' + val).getList().then(function (searchTerms) {
                return searchTerms;
            });
        };

    }])
    .controller("VersionModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'version', 'modalService', 'logService', function ($scope, $uibModalInstance, Restangular, version, modalService, logService) {

        var url = (window as any).CONFIG.version_info_url + 'releasenotes/projects/' + (window as any).CONFIG.PROJECT_CODE + '?' + "_sortBy=date" + "&" + "_sortDirection=desc";
        $scope.versions = [
        ];

        // Parece ser que han cambiado la API y que ahora "success" y "error" van dentro del diccionario. 

        $.ajax({
            type: "GET",
            url: url,
            xhrFields: {
                withCredentials: false
            },
            success: function (data) {
                logService.debug("Success:")
                logService.debug(data);
                $scope.versions = data.rows;
                if ($scope.versions.length > 0) $scope.versions[0].isOpen = true;
                if (!$scope.$$phase) $scope.$apply();
            },
            error: function (data) {

                logService.error("Error:");
                logService.error(data);
            }
        })

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }])

/**
 * minimalizaSidebar - Directive for minimalize sidebar
*/
.directive('minimalizaSidebar',['$timeout', function minimalizaSidebar($timeout) {
    return {
        restrict: 'A',
        template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.minimalize = function () {
                $("body").toggleClass("mini-navbar");
                if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
                    // Hide menu in order to smoothly turn on when maximize menu
                    $('#side-menu').hide();
                    // For smoothly turn on menu
                    $timeout(function () {
                        $('#side-menu').fadeIn(500);
                    }, 100);
                } else {
                    // Remove all inline style from jquery fadeIn function to reset menu state
                    $('#side-menu').removeAttr('style');
                }
                $(window).trigger("resize");
            }
        }]
    };
}])



